import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonGroup, Container, FormFeedback, FormGroup, Modal, ModalBody } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';
import Select from 'react-select';

import * as BillAdditionsApi from '../../api/billAdditions';
import * as DocumentApi from '../../api/document';

import Localization from '../../config/localization';
import { ADMIN, CRC } from '../../constants/accountType';
import { UTILITY_TYPES } from '../../constants/utilityType';

import BackButton from '../../components/BackButton';
import CustomFile from '../../components/File';
import FileUpload from '../../components/FileUpload';
import Loader from '../../components/Loader';
import CloseSvg from '../../components/Svg/close';
import DownloadSvg from '../../components/Svg/download';
import ElectricEnergySvg from '../../components/Svg/electricEnergy';
import NaturalGasSvg from '../../components/Svg/naturalGas';
import WarningSvg from '../../components/Svg/warning';

import Notifications from '../../lib/notifications';
import {
  DateToMonth,
  DownloadFile,
  GetMonthFromSeason,
  GetMonthsForPaymentsAdditions,
  GetYearFromSeason,
  ToFloat,
  ToNumber,
  ToString
} from '../../lib/utils';

import './PaymentsReports.scss';
import { isAccountType } from '../../lib/user';
import { REPORT_TYPE } from '../../constants/report-type';
import Centralizator from './components/Centralizator';
import SearchHeader from './components/SearchHeader';
import DatePicker from '../../components/DatePicker';
import { MIN_ADDITION_REPORT_DATE } from '../../constants/addition';
import CheckBox from '../../components/Input/Checkbox';
import Label from 'reactstrap/lib/Label';
import Input from 'reactstrap/lib/Input';
import { AID_TYPES } from '../../constants/aidType';
import { Months } from '../../config/localization/ro';
import moment from 'moment';

type IProps = PaymentsReportsAddition.IProps & ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

const selectorStyles = {
  dropdownIndicator: (baseStyles: { [property: string]: string | number }) => ({
    ...baseStyles,
    backgroundColor: '#f11c0a',
    color: 'white',
    margin: '2px 2px 2px -1px',
    ':hover': {
      color: 'white',
      backgroundColor: '#d51607'
    }
  }),
  control: (baseStyles: { [property: string]: string | number }) => ({
    ...baseStyles,
    cursor: 'pointer',
    border: '2px solid #bfbfbf'
  }),
  singleValue: (baseStyles: { [property: string]: string | number }) => ({
    ...baseStyles,
    color: '#666'
  })
};

class PaymentsReportsAddition extends React.Component<IProps, PaymentsReportsAddition.IState> {
  state: PaymentsReportsAddition.IState = {
    loading: false,
    loadingMessage: '',

    confirmNewImport: false,
    file: undefined,
    invalidFile: false,
    uploadPercent: undefined,
    uploadedFiles: undefined,

    importNewDocument: false,
    payments: { ee: undefined, gn: undefined },
    reportType: ['pdf'],
    selectedCompany: Localization.Companies[0].companyCode as Utils.CompanyCodes,
    selectedMonth: undefined,
    reportState: undefined,

    utilityType: undefined,

    season: Localization.beneficiaryAddSeasonSelect[1].value as 1,

    utilitiesOptions: [],
    monthsOptions: [],
    reimbursementTypesOptions: []
  };

  showCityHallSelect = isAccountType(CRC, this.props.Auth) || isAccountType(ADMIN, this.props.Auth);
  isAdmin = isAccountType(ADMIN, this.props.Auth);
  searchRef = React.createRef<any>();

  _getSearch = (searchKey: string) => {
    return this.searchRef.current && this.searchRef.current.get(searchKey);
  };

  async componentDidMount() {
    const MONTHS = GetMonthsForPaymentsAdditions();
    const now = DateToMonth();

    await $('#season').selectmenu({ change: this._setSeason });

    await this.setState({ selectedMonth: (MONTHS.indexOf(now) !== -1 && now) || MONTHS[0] });

    return !this.showCityHallSelect && this._getPayments();
  }

  renderHeader = () => {
    return (
      <div className="p-0 mx-0 mx-2 mt-4 mb-5 d-flex">
        <div className="my-auto mr-3">
          <h4 className="eon-title eon-red">{this._getTitle()}</h4>
          {this._getSubtitle() && <p className="mt-2 eon-title eon-middle-grey wrap-pre-line">{this._getSubtitle()}</p>}
        </div>

        {!this.state.importNewDocument && (
          <div className={`d-flex payments-reports-border px-4 mr-auto ${ToString(this.state.importNewDocument && 'disabled')}`}>
            <FormGroup className="m-auto">
              <fieldset className="eon-select">
                <DatePicker
                  name="selectedMonth"
                  id="selectedMonth"
                  value={this.state.selectedMonth}
                  onChange={this._selectMonth}
                  className="eon-input-text"
                  minDate={MIN_ADDITION_REPORT_DATE}
                />
                <FormFeedback tooltip>{Localization.beneficiaryAddStartDateError}</FormFeedback>
              </fieldset>
            </FormGroup>
          </div>
        )}

        {this.showCityHallSelect && !this.state.importNewDocument && (
          <Centralizator disabled={this.state.importNewDocument} isAdmin={this.isAdmin} download={this._downloadCentralizator} />
        )}
      </div>
    );
  };

  renderUnavailableData = () => {
    if (
      (this.state.payments && (this._paymentHasData(this.state.payments.ee) || this._paymentHasData(this.state.payments.gn))) ||
      (Localization.Companies && Localization.Companies.length)
    ) {
      return null;
    }

    return (
      <React.Fragment>
        <hr className="my-5 py-4" />
        <div className="d-flex">
          <p className="eon-title eon-middle-grey strong text-nowrap w-auto mx-auto">{Localization.paymentsReportsUnavailableData}</p>
        </div>
      </React.Fragment>
    );
  };

  renderCompanies = () => {
    return (
      <div className="d-flex px-5">
        {Localization.Companies.map(company => (
          <div
            key={company.companyCode}
            id={company.companyCode}
            onClick={this._selectCompany}
            className={`w-${100 / Localization.Companies.length} px-3 text-center c-pointer-no-color ${
              this.state.selectedCompany === company.companyCode ? 'bg-eon-turquoise-active' : 'bg-eon-lightgrey'
            }`}
          >
            <h4 className="eon-title eon-white m-auto p-3">{company.name}</h4>
          </div>
        ))}
      </div>
    );
  };

  renderImportButton = () => {
    return (
      <div className="mt-5 px-5 d-flex justify-content-end">
        <button className="eon-button bg-eon-red eon-white" onClick={this._doImport}>
          <span className="px-3">{Localization.paymentsReportsImportButton}</span>
        </button>
      </div>
    );
  };

  renderLabelData = (title = '', calculatedPayments: BillAids.ICalculate[], skipTotal = false, reportState: string) => {
    if (!calculatedPayments || !calculatedPayments.length) {
      return null;
    }

    return (
      <div className="mt-3">
        <CheckBox
          name="reportState"
          checked={this.state.reportState === reportState}
          className="my-auto mr-2"
          onClick={this._onRadioBtnClick}
          data-report-state={reportState}
        >
          <p className="eon-title eon-black eon-bold text-nowrap h-100">{title}</p>
        </CheckBox>
        {calculatedPayments.map(payment => (
          <div key={payment.label} className="row px-5 mr-5">
            <p className="col-4 m-0 p-0">{`${Localization.Months[GetMonthFromSeason(payment.label)]} ${GetYearFromSeason(
              payment.label
            )}`}</p>
            <p className="col-3 m-0 p-0 eon-bold">{`${payment.valueSum} ${Localization.currency}`}</p>
            <p className="col-3 m-0 p-0">
              {Localization.formatString(Localization.paymentsReportsBeneficiaryCount, payment.valueBeneficiari)}
            </p>
          </div>
        ))}
        {!skipTotal && (
          <div className="row px-5 mr-5 mt-2">
            <div className="border-top my-2 w-100 mr-5" />
            <p className="col-4 m-0 p-0 eon-bold">{Localization.paymentsReportsTotal}</p>
            <p className="col-3 m-0 p-0 eon-bold">{`${this._countSum(calculatedPayments)} ${Localization.currency}`}</p>
          </div>
        )}
      </div>
    );
  };

  renderPaymentDetails = (utilityType: Utils.IUtilityType) => {
    if (!this.state.payments) {
      return null;
    }

    const payment = this.state.payments[utilityType];

    if (!payment) {
      return null;
    }

    return (
      <div className="px-5">
        {this.renderLabelData(Localization.paymentsReportsInitialTitle, payment.initial, false, `${utilityType}.initial`)}
        {this.renderLabelData(Localization.paymentsReportsRecalculationTitle, payment.recalculari, false, `${utilityType}.recalculari`)}
        {this.renderLabelData(Localization.paymentsReportsSkipedTitle, payment.omis, false, `${utilityType}.omis`)}
      </div>
    );
  };

  renderPayment = () => {
    if (!this.state.payments || (!this.state.payments.gn && !this.state.payments.ee)) {
      return null;
    }

    const count = this._countTotal();

    return (
      <div className="mt-4 px-5">
        <h4 className="eon-quote eon-black eon-bold px-5">{Localization.paymentsReportsSummaryReports}</h4>

        <ButtonGroup className="d-flex flex-column">
          {this.state.payments.gn && (
            <div className="px-5 mx-5 mt-4">
              <CheckBox
                name="utilityType"
                checked={this.state.utilityType === UTILITY_TYPES.NATURAL_GAS}
                className="my-auto mr-2"
                onClick={this._onUtilityTypeBtnClick}
                data-utility-type={UTILITY_TYPES.NATURAL_GAS}
              >
                <NaturalGasSvg className="my-auto mx-2" />
                <p className="eon-title eon-red eon-bold my-auto text-nowrap h-100">{Localization.paymentsReportsNaturalGas}</p>
              </CheckBox>
              {this.renderPaymentDetails('gn')}
            </div>
          )}

          {this.state.payments.ee && (
            <div className="px-5 mx-5 mt-4">
              <CheckBox
                name="utilityType"
                checked={this.state.utilityType === UTILITY_TYPES.ELECTRIC_ENERGY}
                className="my-auto mr-2"
                onClick={this._onUtilityTypeBtnClick}
                data-utility-type={UTILITY_TYPES.ELECTRIC_ENERGY}
              >
                <ElectricEnergySvg className="my-auto mx-2" />
                <p className="eon-title eon-red eon-bold my-auto text-nowrap h-100">{Localization.paymentsReportsElectricEnergy}</p>
              </CheckBox>

              {this.renderPaymentDetails('ee')}
            </div>
          )}
        </ButtonGroup>

        <div className="d-flex justify-content-center mt-5">
          <p className="text-center eon-bold ml-auto mr-1">{`${count.sum} ${Localization.currency}`}</p>
          <p className="text-center ml-1 mr-auto">{`${Localization.formatString(
            Localization.paymentsReportsBeneficiaryCount,
            count.count
          )}`}</p>
        </div>

        <div className="mt-5 px-5 custom-width">
          <p className="eon-title eon-black eon-bold text-nowrap h-100">{Localization.paymentsReportsDownloadLabel}</p>
          <div className="d-flex my-4">
            <CheckBox
              id="pdf"
              checked={this.state.reportType && this.state.reportType.indexOf('pdf') !== -1}
              className="m-auto align-items-center"
              onClick={this._setReportType}
            >
              <h5 className="eon-title eon-black m-auto">{Localization.paymentsReportsDownloadPDF}</h5>
            </CheckBox>
            <CheckBox
              id="xls"
              checked={this.state.reportType && this.state.reportType.indexOf('xls') !== -1}
              className="m-auto align-items-center"
              onClick={this._setReportType}
            >
              <h5 className="eon-title eon-black m-auto">{Localization.paymentsReportsDownloadXLS}</h5>
            </CheckBox>
          </div>

          <button
            className="eon-button bg-eon-red eon-white"
            onClick={this._downloadDocuments}
            disabled={!(this.state.reportType && this.state.reportType.length) || !this.state.utilityType || !this.state.reportState}
          >
            <span className="px-2">
              {Localization.paymentsReportsDownloadButton}
              <DownloadSvg className="ml-2 my-auto" />
            </span>
          </button>
        </div>
      </div>
    );
  };

  renderFile = () => {
    if (this.state.file && this.state.uploadPercent) {
      return (
        <CustomFile
          fileName={this.state.file.name}
          fileSize={this.state.file.size}
          progressMessage={Localization.paymentsReportsImportUploadMessage}
          progressColor="eon-red"
          progressValue={this.state.uploadPercent}
        />
      );
    }

    return (
      <FileUpload
        FileChange={this._fileChange}
        RemoveFile={this._removeFile}
        DoUploadFile={this._modalImport}
        invalidFile={this.state.invalidFile}
        file={this.state.file}
        errorFeedback={Localization.paymentsReportsImportFileUploadError}
        dragMessage={Localization.paymentsReportsImportFileUploadDrag}
        deleteButton={Localization.paymentsReportsImportDeleteFile}
        uploadButton={Localization.paymentsReportsImportUploadButton}
        disabled={this.showCityHallSelect && !this._getSearch('cityHallSearch')}
        accepts='.pdf'
      />
    );
  };

  renderImportCompanies = () => {
    if (!this.state.selectedUtility || !this.state.selectedMonthYear || !this.state.selectedReimbursementType) return null;

    return (
      <div className='mt-3'>
        {!this.state.uploadPercent && (
          <React.Fragment>
            <h5 className="eon-title eon-black eon-bold">{Localization.paymentsReportsImportCompanyLabel}</h5>

            <div className="mx-2">
              {Localization.Companies.map(company => (
                <label
                  key={company.companyCode}
                  id={company.companyCode}
                  className={`eon-radio-label bg-eon-red w-100 eon-red ${
                    company.companyCode === this.state.selectedCompany ? 'checked' : ''
                  } ${
                    this.state.uploadedFiles &&
                    this.state.uploadedFiles.find(uploadedFile => uploadedFile && uploadedFile.companyCode === company.companyCode)
                      ? 'disabled'
                      : ''
                  }`}
                  onClick={this._selectCompany}
                >
                  {company.name}
                </label>
              ))}
            </div>
          </React.Fragment>
        )}
        {this.renderFile()}
      </div>
    );
  };

  selectUtility = (selectedOption: Utils.ISelect) => {
    if (!this.state.documentsUtilities) return;

    const months = Object.keys(this.state.documentsUtilities.utilities[selectedOption.value]);

    this.setState({
      selectedUtility: selectedOption,
      selectedMonthYear: null,
      selectedReimbursementType: undefined,
      reimbursementTypesOptions: [],
      monthsOptions: months.map(month => ({
        value: ToString(month),
        label: `${Months[moment(month).format('MM')]} ${moment(month).format('YYYY')}`
      }))
    });
  };

  selectMonthYear = (selectedMonthYear: Utils.ISelect) => {
    if (!this.state.documentsUtilities || !this.state.selectedUtility) return;

    const reimbursementTypes = this.state.documentsUtilities.utilities[this.state.selectedUtility.value][selectedMonthYear.value];

    this.setState({
      selectedMonthYear: selectedMonthYear,
      selectedReimbursementType: null,
      reimbursementTypesOptions: reimbursementTypes.map(reimbursementType => ({
        value: reimbursementType,
        label: reimbursementType
      }))
    });
  };

  selectReimbursementType = (selectedReimbursementType: Utils.ISelect) => {
    this.setState({
      selectedReimbursementType: selectedReimbursementType
    });
  };

  renderUtilitiesSelector = () => {
    if (!this.state.utilitiesOptions.length) return null;

    return (
      <div className="w-25">
        <label>{Localization.paymentsReportsSelectUtility}</label>
        <Select
          value={this.state.selectedUtility}
          options={this.state.utilitiesOptions}
          className="eon-react-select"
          styles={selectorStyles}
          onChange={this.selectUtility}
        />
      </div>
    );
  };

  renderMonthsSelector = () => {
    if (!this.state.monthsOptions.length) return null;

    return (
      <div className="w-25 mt-3">
        <label>{Localization.paymentsReportsSelectMonth}</label>
        <Select
          value={this.state.selectedMonthYear}
          options={this.state.monthsOptions}
          className="eon-react-select"
          styles={selectorStyles}
          onChange={this.selectMonthYear}
        />
      </div>
    );
  };

  renderReimbursementTypesSelector = () => {
    if (!this.state.reimbursementTypesOptions.length) return null;

    return (
      <div className="w-25 mt-3">
        <label>{Localization.paymentsReportsSelectReimbursementType}</label>
        <Select
          value={this.state.selectedReimbursementType}
          options={this.state.reimbursementTypesOptions}
          className="eon-react-select"
          styles={selectorStyles}
          onChange={this.selectReimbursementType}
        />
      </div>
    );
  };

  renderSelectors = () => {
    return (
      <>
        {this.renderUtilitiesSelector()}
        {this.renderMonthsSelector()}
        {this.renderReimbursementTypesSelector()}
      </>
    );
  };

  renderImportContainer = () => {
    const selectedCompany = Localization.Companies.find(company => company.companyCode === this.state.selectedCompany);

    const count = this._countTotal();
    const selectedCityHall = this._getSearch('cityHallSearch');

    return (
      <div className="mt-5 mx-2">
        {this.renderCityHallSelect({
          isAdmin: false,
          onCityHallChange: async (place: Utils.ICityHall) => {
            await this._getDocuments(place && place.cityHallId);
            await this._getDocumentsUtilities(place && place.cityHallId);
          }
        })}

        {this.state.errorMessage ? (
          <p>{this.state.errorMessage}</p>
        ) : (
          <>
            {this.renderSelectors()}
            {this.renderImportCompanies()}
          </>
        )}

        <Modal isOpen={this.state.confirmNewImport} centered size="md" toggle={this._modalImport}>
          <ModalBody className="px-5 pt-5 pb-4">
            <div className="d-flex justify-content-center">
              <WarningSvg className="my-auto" />
              <h5 className="eon-title eon-black eon-bold ml-3 my-auto">{Localization.paymentsReportsImportModalTitle}</h5>
            </div>

            <h5 className="eon-copy eon-black text-center mt-4 mb-auto mx-auto">{Localization.paymentsReportsImportModalMessage}</h5>

            <h5 className="eon-copy eon-black text-center mt-4 mb-auto mx-auto">{Localization.paymentsReportsImportModalCompany}</h5>
            <h5 className="eon-copy eon-black m-auto text-center eon-bold">{selectedCompany && selectedCompany.name}</h5>

            {this.showCityHallSelect && selectedCityHall && (
              <React.Fragment>
                <h5 className="eon-copy eon-black text-center mt-4 mb-auto mx-auto">{Localization.paymentsReportsImportModalCityHall}</h5>
                <h5 className="eon-copy eon-black m-auto text-center eon-bold">{selectedCityHall.name}</h5>
              </React.Fragment>
            )}

            <h5 className="eon-copy eon-black text-center mt-4 mb-auto mx-auto">{Localization.paymentsReportsImportModalMonth}</h5>
            <h5 className="eon-copy eon-black m-auto text-center eon-bold">{`${
              Localization.Months[GetMonthFromSeason(this.state.selectedMonth)]
            } ${GetYearFromSeason(this.state.selectedMonth)}`}</h5>

            <h5 className="eon-copy eon-black text-center mt-4 mb-auto mx-auto">{Localization.paymentsReportsImportModalValue}</h5>
            <h5 className="eon-copy eon-black m-auto text-center eon-bold">{`${count.sum} ${Localization.currency}`}</h5>

            <div className="mt-4">
              <button className="eon-button bg-eon-red eon-white" onClick={this._doUploadFile}>
                <span className="px-2">{Localization.paymentsReportsImportModalButtonSave}</span>
              </button>

              <button className="eon-button bg-eon-white eon-middle-grey" onClick={this._modalImport}>
                <span className="px-2">
                  <CloseSvg className="my-auto mx-2 align-baseline" />
                  {Localization.paymentsReportsImportModalButtonCancel}
                </span>
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  };

  renderFlow = () => {
    if (this.state.importNewDocument) {
      return (
        <React.Fragment>
          {this.renderHeader()}
          {this.renderImportContainer()}

          {this.renderUploadedFiles()}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {this.renderHeader()}
        {this.renderUnavailableData()}

        {this.renderCityHallSelect()}

        {this.renderCompanies()}
        {this.renderImportButton()}
        {this.renderPayment()}
      </React.Fragment>
    );
  };

  _setSeason = async (event: Event | React.ChangeEvent<HTMLInputElement>) => {
    const oldSeason = this.state.season;
    const season = (event && event.target && (event.target as any).value ? ToNumber((event.target as any).value) : undefined) as
      | 0
      | 1
      | undefined;

    await this.setState({ season });

    if (oldSeason !== season) await this._getPayments();
  };

  renderCityHallSelect = (options = {} as PaymentsReports.ISearchHeaderRenderOptions) => {
    const {
      isAdmin = this.isAdmin,
      onCityHallChange = (place: Utils.ICityHall) => this._getPayments(undefined, place.cityHallId)
    } = options;

    return (
      <SearchHeader ref={this.searchRef} onCityHallChange={onCityHallChange} isAdmin={isAdmin} cityHallSelect={this.showCityHallSelect}>
        {!this.state.importNewDocument && (
          <div className="d-flex">
            <FormGroup className="mt-4 mx-auto w-25 d-inline-block remove-arrow">
              <Label className="text-nowrap" for="stateBudgetAmount">
                {Localization.beneficiaryAddSeason}
              </Label>
              <fieldset className="eon-select large eon-red">
                <Input
                  type="select"
                  name="season"
                  id="season"
                  value={this.state.season}
                  onChange={this._setSeason}
                  className="d-none eon-select large eon-red"
                >
                  {Localization.beneficiaryAddSeasonSelect.map(el => (
                    <option key={el.value} value={el.value} selected={el.selected}>
                      {el.label}
                    </option>
                  ))}
                </Input>
              </fieldset>
            </FormGroup>
          </div>
        )}
      </SearchHeader>
    );
  };

  renderUploadedFiles = () => {
    if (!this.state.uploadedFiles || !this.state.uploadedFiles.length) {
      return null;
    }

    return (
      <div className="position-absolute file-container">
        {this.state.uploadedFiles.map((uploadedFile, index) => (
          <CustomFile
            isReady
            containerClass={ToString(index && 'mt-4')}
            key={uploadedFile.documentId}
            fileName={uploadedFile.name}
            downloadButton={
              <DownloadSvg
                className="mx-1 mr-2 my-auto c-pointer-no-color"
                id={ToString(uploadedFile.documentId)}
                onClick={this._downloadFile}
              />
            }
          />
        ))}
      </div>
    );
  };

  render() {
    return (
      <Container className="payments-reports p-0 my-5 position-relative">
        <BackButton />

        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        {this.renderFlow()}
      </Container>
    );
  }

  _onUtilityTypeBtnClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const utilityType = ((event && event.currentTarget && event.currentTarget.dataset && event.currentTarget.dataset.utilityType) ||
      this.state.utilityType) as Utils.IUtilityType;
    let reportState = (this.state.reportState && this.state.reportState.split('.')) || [];

    if (reportState && reportState.length > 1) {
      reportState = reportState.splice(0, 1, utilityType);
    }

    this.setState({ utilityType, reportState: reportState.join('.') as Utils.ReportState });
  };

  _onRadioBtnClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const reportState = ((event && event.currentTarget && event.currentTarget.dataset && event.currentTarget.dataset.reportState) ||
      this.state.reportState) as Utils.ReportState;
    this.setState({ reportState, utilityType: reportState.split('.')[0] as Utils.IUtilityType });
  };

  _countSum = (calculatedPayments?: BillAids.ICalculate[]) => {
    if (!calculatedPayments) {
      return 0;
    }

    const filtredPayments = calculatedPayments.filter(payment => payment && payment.valueSum);

    const mapedPayments = filtredPayments && filtredPayments.length > 0 && filtredPayments.map(payment => ToFloat(payment.valueSum));

    if (!mapedPayments || mapedPayments.length < 2) {
      return ToFloat(mapedPayments && mapedPayments[0]);
    }

    return ToFloat(mapedPayments.reduce((a, b) => ToFloat(a) + ToFloat(b))).toFixed(2);
  };

  _countTotal = (payments = this.state.payments) => {
    if (!payments) {
      return { sum: ToFloat(0).toFixed(2), count: 0 };
    }

    const dataEE =
      (payments.ee && ([] as BillAids.ICalculate[]).concat(payments.ee.initial, payments.ee.omis, payments.ee.recalculari)) || [];
    const dataGN =
      (payments.gn && ([] as BillAids.ICalculate[]).concat(payments.gn.initial, payments.gn.omis, payments.gn.recalculari)) || [];

    const filtredPayments = [...dataEE, ...dataGN].filter(payment => payment && (payment.valueSum || payment.valueBeneficiari));

    const mapedPayments =
      filtredPayments &&
      filtredPayments.length > 0 &&
      filtredPayments.map(payment => ({ sum: ToFloat(payment.valueSum), count: ToFloat(payment.valueBeneficiari) }));

    if (!mapedPayments || mapedPayments.length < 2) {
      return {
        sum: ToFloat(mapedPayments && mapedPayments[0].sum).toFixed(2),
        count: ToFloat(mapedPayments && mapedPayments[0].count)
      };
    }

    return {
      count: ToFloat(mapedPayments.map(payment => payment.count).reduce((a, b) => ToFloat(a) + ToFloat(b))),
      sum: ToFloat(mapedPayments.map(payment => payment.sum).reduce((a, b) => ToFloat(a) + ToFloat(b))).toFixed(2)
    };
  };

  _getTitle = () => {
    if (this.state.importNewDocument) {
      return Localization.paymentsReportsImportTitleAddition;
    }

    return Localization.paymentsReportsAdditionTitle;
  };

  _getSubtitle = () => {
    if (this.state.importNewDocument) {
      return Localization.paymentsReportsImportSubtitle;
    }

    return null;
  };

  _downloadFile = async (event: React.MouseEvent<SVGAElement>) => {
    try {
      if (event.preventDefault) {
        event.preventDefault();
      }

      const target = event.currentTarget || event.target || {};

      const foundFile =
        this.state.uploadedFiles &&
        this.state.uploadedFiles.find(uploadedFile => ToString(uploadedFile.documentId) === ToString(target.id));

      if (!foundFile) {
        return undefined;
      }

      const response = await DocumentApi.GetDocument(foundFile.documentId);

      await DownloadFile(response.data, foundFile.name, { type: response.headers['content-type'] });

      return this.setState({ loading: false, loadingMessage: '' });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false, loadingMessage: '' });
    }
  };

  _downloadCentralizator = async (event: React.MouseEvent<HTMLDivElement>, options = {} as PaymentsReports.IDownloadCentralizerOptions) => {
    const { reportType, reportFormat = 'pdf', utilityType, fileName } = options;
    try {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      if (!this.state.reportType || !this.state.reportType.length) {
        return undefined;
      }

      await this.setState({ loading: true, loadingMessage: '' });

      const selectedCityHall = this._getSearch('cityHallSearch');
      const selectedCRC = this._getSearch('crcSearch');
      const selectedCounty = this._getSearch('countySearch');

      const response = await BillAdditionsApi.DownloadDocument({
        companyCode: this.state.selectedCompany,
        cityHallId: selectedCityHall && selectedCityHall.cityHallId,
        crc: selectedCRC && selectedCRC.crc,
        countyCode: selectedCounty && selectedCounty.countyCode,
        month: ToString(this.state.selectedMonth) as keyof Month.IGetMonths,
        reportFormat,
        reportType,
        utilityType,
        season: this.state.season
      });

      await DownloadFile(response.data, `${fileName}.${reportFormat}`, { type: response.headers['content-type'] });

      return this.setState({ loading: false, loadingMessage: '' });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false, loadingMessage: '' });
    }
  };

  _getDocumentsUtilities = async (selectedCityHall = this.props.Auth && this.props.Auth.cityHallId) => {
    if (!selectedCityHall) return;

    this.setState({ loading: true, loadingMessage: '' });

    try {
      const response = await DocumentApi.ListDocumentsUtilities({
        cityHallId: selectedCityHall,
        aidType: AID_TYPES.ADDITION
      });

      if (!response.data.utilities || Object.keys(response.data.utilities).length === 0) {
        this.setState({ errorMessage: Localization.paymentsReportsCanNotUploadFile });
        return;
      } else {
        this.setState({
          documentsUtilities: response.data,
          utilitiesOptions: [],
          monthsOptions: [],
          reimbursementTypesOptions: [],
          selectedUtility: null,
          selectedMonthYear: null,
          selectedReimbursementType: null
        });

        const utilitiesOptions: Utils.ISelect[] = [];
        if (response.data.utilities.EE) {
          utilitiesOptions.push({
            value: 'EE',
            label: Localization.Utilities.EE
          });
        }
        if (response.data.utilities.GN) {
          utilitiesOptions.push({
            value: 'GN',
            label: Localization.Utilities.GN
          });
        }
        if (utilitiesOptions.length) this.setState({ utilitiesOptions });
      }
    } catch (error) {
      Notifications.error(error && error.message);
    } finally {
      this.setState({ loading: false, loadingMessage: '' });
    }
  };

  _getDocuments = async (selectedCityHall = this.props.Auth && this.props.Auth.cityHallId) => {
    try {
      if (!selectedCityHall) return;

      this.setState({ loading: true, loadingMessage: '' });

      const response = await DocumentApi.ListDocuments({
        cityHallId: selectedCityHall,
        aidType: AID_TYPES.ADDITION
      });

      await this.setState({ uploadedFiles: response.data && response.data.length ? response.data : undefined });

      const canUploadForCompanies = Localization.Companies.map(
        company => !(this.state.uploadedFiles && this.state.uploadedFiles.find(file => file.companyCode === company.companyCode))
      );

      const index = canUploadForCompanies.findIndex(Boolean);

      return this._selectCompany({
        currentTarget: { id: ToString(Localization.Companies[index] && Localization.Companies[index].companyCode) },
        preventDefault: () => undefined
      } as React.MouseEvent<HTMLLabelElement>);
    } catch (error) {
      Notifications.error(error && error.message);
    } finally {
      this.setState({ loading: false, loadingMessage: '' });
    }
  };

  _doImport = () => {
    return this.setState({ importNewDocument: true }, async () => {
      await this._getDocuments();
      await this._getDocumentsUtilities();
    });
  };

  _fileChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
    if (!event) {
      return undefined;
    }

    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const file = element.files ? element.files[0] : undefined;
    element.value = '';

    if (!file) {
      return this.setState({ invalidFile: true });
    }

    const allow = element.accept.split(',').find(accept => new RegExp(accept.trim(), 'i').test(file.name));

    if (!allow) {
      return this.setState({ invalidFile: true });
    }

    return this.setState({ file, invalidFile: false });
  };

  _modalImport = () => {
    return this.setState({ confirmNewImport: !this.state.confirmNewImport });
  };

  _doUploadFile = async (event?: React.MouseEvent<HTMLButtonElement>) => {
    if (!this.state.selectedMonthYear || !this.state.selectedReimbursementType || !this.state.selectedUtility) return;

    try {
      if (event) {
        event.preventDefault();
      }

      const selectedCityHall = this._getSearch('cityHallSearch');

      if (this.showCityHallSelect && !selectedCityHall) {
        return undefined;
      }

      await this.setState({ confirmNewImport: false });

      if (!this.state.file) {
        return this.setState({ invalidFile: true });
      }

      const formData = new FormData();

      formData.append('file', this.state.file);

      await DocumentApi.UploadDocument(
        formData,
        {
          cityHallId: selectedCityHall && selectedCityHall.cityHallId,
          companyCode: this.state.selectedCompany,
          month: this.state.selectedMonthYear.value,
          aidType: AID_TYPES.ADDITION,
          reimbursementType: this.state.selectedReimbursementType.value,
          utilityType: this.state.selectedUtility.value
        },
        {
          onUploadProgress: progress => {
            return this.setState(
              { uploadPercent: ToFloat(Math.round((ToFloat(progress.loaded) * 100) / ToFloat(progress.total))) },
              this.forceUpdate
            );
          }
        }
      );

      Notifications.success(Localization.paymentsReportsImportFileSuccess);

      await this.setState({
        confirmNewImport: false,
        file: undefined,
        importNewDocument: false,
        invalidFile: false,
        uploadPercent: undefined
      });

      return this.componentDidMount();
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false, loadingMessage: '', uploadPercent: undefined });
    }
  };

  _removeFile = (event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault();
    }

    return this.setState({ file: undefined });
  };

  _paymentHasData = (payment = this.state.payments && this.state.payments.ee) => {
    return !!(
      payment &&
      ((payment.initial && payment.initial.length) ||
        (payment.omis && payment.omis.length) ||
        (payment.recalculari && payment.recalculari.length))
    );
  };

  _downloadDocuments = async (event: React.MouseEvent<HTMLButtonElement>) => {
    try {
      if (event.preventDefault) {
        event.preventDefault();
      }

      if (!this.state.reportType || !this.state.reportType.length || !this.state.utilityType || !this.state.reportState) {
        return undefined;
      }

      const reportType = REPORT_TYPE[this.state.utilityType as Utils.IUtilityType];

      await this.setState({ loading: true, loadingMessage: '' });
      const selectedCityHall = this._getSearch('cityHallSearch');

      const responses = await Promise.all(
        this.state.reportType.map(reportFormat =>
          BillAdditionsApi.DownloadDocument({
            cityHallId: selectedCityHall && selectedCityHall.cityHallId,
            companyCode: this.state.selectedCompany,
            month: ToString(this.state.selectedMonth) as keyof Month.IGetMonths,
            reportFormat,
            reportType,
            reportState: this.state.reportState && (this.state.reportState.split('.')[1] as Utils.ReportState),
            season: this.state.season
          })
        )
      );

      let reportTypeLocalization = '';

      if (reportType === REPORT_TYPE[UTILITY_TYPES.NATURAL_GAS])
        reportTypeLocalization = Localization.paymentsReportsDownloadFileNameAdditionsGN;
      else if (reportType === REPORT_TYPE[UTILITY_TYPES.ELECTRIC_ENERGY])
        reportTypeLocalization = Localization.paymentsReportsDownloadFileNameAdditionsEE;

      await Promise.all(
        responses.map((response, index) =>
          DownloadFile(
            response.data,
            `${Localization.formatString(
              Localization.paymentsReportsDownloadFileName,
              GetYearFromSeason(this.state.selectedMonth),
              Localization.Months[GetMonthFromSeason(this.state.selectedMonth)],
              reportTypeLocalization
            )}.${this.state.reportType[index]}`
          )
        )
      );

      return this.setState({ loading: false, loadingMessage: '' });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false, loadingMessage: '' });
    }
  };

  _getPayments = async (
    company = Localization.Companies[0],
    selectedCityHall: AuthReducer.IState['cityHallId'] = this.props.Auth && this.props.Auth.cityHallId
  ) => {
    try {
      const cityHallSearch = this._getSearch('cityHallSearch');

      if (!selectedCityHall && cityHallSearch) {
        selectedCityHall = cityHallSearch.cityHallId;
      }

      await this.setState({ loading: true, loadingMessage: '' });

      const responses = await Promise.all([
        ...Object.keys(UTILITY_TYPES).map(key =>
          BillAdditionsApi.CalculatePayments({
            cityHallId: selectedCityHall,
            companyCode: company.companyCode as Utils.CompanyCodes,
            month: ToString(this.state.selectedMonth) as keyof Month.IGetMonths,
            utilityType: UTILITY_TYPES[key],
            season: this.state.season
          })
        )
      ]);

      const payments: PaymentsReportsAddition.IState['payments'] = { ee: undefined, gn: undefined };

      responses.forEach(response => {
        if (!this._paymentHasData(response.data)) {
          return undefined;
        }

        const type = response.data.utilityType as Utils.IUtilityType;

        return (payments[type] = response.data);
      });

      return this.setState({ loading: false, loadingMessage: '', payments });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _setReportType = (event: React.MouseEvent<HTMLLabelElement>) => {
    event.preventDefault();

    const target = event.currentTarget || event.target || {};
    const reportType = this.state.reportType || [];

    const id = target.id as Utils.FileType;
    const index = reportType.indexOf(id);

    if (index !== -1) {
      reportType.splice(index, 1);
    } else {
      reportType.push(id);
    }

    return this.setState({ reportType });
  };

  _selectMonth = async (event: any) => {
    if (event.preventDefault) {
      event.preventDefault();
    }

    const target = event.currentTarget || event.target || {};

    const prevMonth = this.state.selectedMonth;

    await this.setState({ selectedMonth: target.value as keyof Month.IGetMonths });

    if (prevMonth !== this.state.selectedMonth) {
      return this._getPayments();
    }
    return undefined;
  };

  _selectCompany = async (event: React.MouseEvent<HTMLDivElement> | React.MouseEvent<HTMLLabelElement>) => {
    if (event.preventDefault) {
      event.preventDefault();
    }

    const target = event.currentTarget || event.target || {};

    const prevCompany = this.state.selectedCompany;

    if (this.state.uploadedFiles && this.state.uploadedFiles.find(uploadedFile => uploadedFile && uploadedFile.companyCode === target.id)) {
      return undefined;
    }

    await this.setState({ selectedCompany: target.id as Utils.CompanyCodes });

    if (prevCompany !== this.state.selectedCompany) {
      return this._getPayments(Localization.Companies.find(company => company.companyCode === this.state.selectedCompany));
    }

    return undefined;
  };
}

const mapStateToProps = (state: General.Store) => ({ Auth: state.Auth });

const mapDispatchToProps = (dispatch: Dispatch) => ({ ...bindActionCreators({}, dispatch) });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentsReportsAddition);
